"use client";

import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import { Drawer } from "antd";
import { usePathname, useRouter } from "next/navigation";
import logo from "@/assets/images/logos/AlfaMall-Logo 90x90 px-01.png";
import {
  APP_NAME,
  CONTINUE_IN_BROWSER_LABEL,
  EXPLORE_IN_APP_LABEL,
  OPEN_APP_LABEL,
  PROMO_POPUP_CLOSED_EVENT,
  isAppPromptDismissed,
  isAppPromptHidden,
  isPromoPopupClosed,
  openApp,
  rememberAppPromptDismissed,
} from "./getOurAppConfig";
import "./GetOurApp.scss";

export default function GetOurAppDrawer() {
  const pathname = usePathname();
  const router = useRouter();
  const pathnameRef = useRef(pathname);
  const [open, setOpen] = useState(false);

  pathnameRef.current = pathname;

  useEffect(() => {
    const showDrawer = () => {
      if (isAppPromptHidden(pathnameRef.current) || isAppPromptDismissed()) {
        return;
      }
      setOpen(true);
    };

    if (isPromoPopupClosed()) {
      showDrawer();
      return;
    }

    window.addEventListener(PROMO_POPUP_CLOSED_EVENT, showDrawer);
    return () => window.removeEventListener(PROMO_POPUP_CLOSED_EVENT, showDrawer);
  }, []);

  useEffect(() => {
    if (isAppPromptHidden(pathname) || isAppPromptDismissed()) {
      setOpen(false);
    }
  }, [pathname]);

  const closeDrawer = () => {
    rememberAppPromptDismissed();
    setOpen(false);
  };

  const continueInBrowser = () => {
    closeDrawer();
  };

  return (
    <Drawer
      placement="bottom"
      open={open}
      closable={false}
      maskClosable
      keyboard={false}
      height="auto"
      rootClassName="get-our-app-drawer"
      onClose={closeDrawer}
    >
      <p className="get-our-app-explore">{EXPLORE_IN_APP_LABEL}</p>
      <div className="get-our-app-row">
        <div className="get-our-app-brand">
          <Image src={logo} alt="AlfaMall" width={48} height={48} />
          <span>{APP_NAME}</span>
        </div>
        <button
          type="button"
          className="get-our-app-open"
          onClick={() => {
            closeDrawer();
            openApp();
          }}
        >
          {OPEN_APP_LABEL}
        </button>
      </div>
      <button
        type="button"
        className="get-our-app-continue"
        onClick={continueInBrowser}
      >
        {CONTINUE_IN_BROWSER_LABEL}
        <span aria-hidden="true">›</span>
      </button>
    </Drawer>
  );
}
